import React, { useState } from 'react';
import AppLoading from '../components/AppLoading';
import { PagesCommonProps } from '../helpers/pagesUtil';
import dashboard3APIsService from '../hooks/dashboard3APIs';
import DrillDownV2 from '../components/drillDowns/DrillDownV2';
import TableGraph from '../components/Charts/comps/TableGraph';
import { selectedDataRowForTableDefaultState } from '../helpers/page1';
import SummaryCardContainer from '../components/SummaryCardsContainer';
import { organisationsWithCoursesOtherActions } from '../helpers/page3';
import { mergeChartConfigWithApiData } from '../helpers/chartConfigHelper';
import { dashboardGraphsOptions, GOOGLE_CHARTS_TYPES } from '../consts/graphs';
import ChartContainer, { ChartContainerProps } from '../components/Charts/ChartContainer';
import useFetchDashboard3Data from '../hooks/fetchDataComponents/useFetchDashboard3Data';

const { BARCHART, TABLE, COLUMNCHART } = GOOGLE_CHARTS_TYPES;

const Page3DashboardGraphs: React.FC<PagesCommonProps> = ({ filters, graphs = [] }) => {
  const {
    data,
    onScroll,
    onSortChange,
    otherActions,
    isLoadingMap,
    endpointsMap,
    exportActions,
    paginationActions,
    } = useFetchDashboard3Data({ filters, graphs });
  const [hoveredRowStye, setHoveredRowStye] = useState<{top?: number, left?: number} | null>(null);
  const [selectedDataRowForTable, setSelectedDataRowForTable] = useState(selectedDataRowForTableDefaultState);

  // Wrapper function to match the generic component's expected signature
  const fetchSubDataWrapper = async (
    params: Record<string, unknown>,
    signal?: AbortSignal
  ) => {
    return dashboard3APIsService.fetchDrillDownSubData(
      params as Parameters<typeof dashboard3APIsService.fetchDrillDownSubData>[0],
      signal
    );
  };

  // Courses drilldown configuration
  const drilldownTypes = [
    {
      label: 'Course',
      value: 'Course',
      fieldName: 'courseId',
      paramName: 'parentId',
      typeValue: 'Course'
    },
    {
      label: 'Organisation',
      value: 'Organisation',
      fieldName: 'organisationId',
      paramName: 'parentId',
      typeValue: 'Organisation'
    }
  ];

  if (isLoadingMap?.fetchSummaryCardsData) return <AppLoading />;

  const baseChartsConfig: ChartContainerProps[] = [
    /*{
      onScroll,
      boxWidth: "95%",
      chartType: AREACHART,
      title: 'Course Overview Trend',
      chartId: "fetchCourseOverviewTrendData",
      options: {
        ...dashboardGraphsOptions.BarChartOptions.GetByColumnLength(
          data?.fetchCourseOverviewTrendData?.data?.[0],
          { v: "% of Completion" }
        ),
        isStacked: false,
      }
    },*/
    {
      onScroll,
      boxWidth: "95%",
      chartType: COLUMNCHART,
      title: 'Course Completion by Month',
      chartId: "fetchCourseCompletionByMonthData",
      options: dashboardGraphsOptions.BarChartOptions.GetByColumnLength(
        data?.fetchCourseCompletionByMonthData?.data?.[0],
        { v: "No. of Courses", h: " "}
      ),
      /*onRowSelect: (param: any) => showCourseNamesOnRowSelect(
        "fetchCourseCompletionByMonthData", param,
        (data?.fetchCourseCompletionByMonthData as any),
        setHoveredRowStye, setSelectedDataRowForTable,
      ),*/
    },
    {
      paginationActions,
      boxWidth: "55%",
      chartType: BARCHART,
      title: 'Course Breakdown',
      chartId: "fetchCourseBreakdownData",
      //otherActions: courseBreakdownOtherActions(filters, setFilters),
      AdditionalDialogComp: <DrillDownV2
        total={
          (data?.fetchSummaryCardsData as any)?.completionCount || 0
        }
        filters={filters}
        fetchMainData={dashboard3APIsService.fetchCoursesBreakdownDrillDownDataV2}
        fetchSubData={fetchSubDataWrapper}
        drilldownTypes={drilldownTypes}
        exportFilenamePrefix="courses-drilldown-export"
      />,
      options: (() => {
        const chartOptions =
          dashboardGraphsOptions.BarChartChartOptions.GetByColumnLength(
            data?.fetchCourseBreakdownData?.data?.[0],
            { h: "% of Completion" }
          );
        return {
          ...chartOptions,
          chartArea: {
            ...chartOptions.chartArea,
            left: 280,
            height: '75%',
          },
          isStacked: true,
        };
      })(),
    },
    /*
    {
      onScroll,
      boxWidth: "20%",
      chartType: TABLE,
      title: "Organisations with Courses",
      chartId: "fetchOrganisationsWithCoursesData",
      options: dashboardGraphsOptions.TableChartOptions,
      data: data?.fetchOrganisationsWithCoursesData?.data,
    },isLoading: isLoadingMap?.fetchUsersCompletedTrendsData,

    {
      onScroll,
      boxWidth: "20%",
      chartType: TABLE,
      title: 'Organisations Without any Courses',
      chartId: "fetchOrganisationsWithoutCoursesData",
      options: dashboardGraphsOptions.TableChartOptions,
      data: data?.fetchOrganisationsWithoutCoursesData?.data,
    },isLoading: isLoadingMap?.fetchUsersCompletedTrendsData,
      */
    {
      onScroll,
      onSortChange,
      boxWidth: "25%",
      chartType: TABLE,
      title: "Organisations with / without Courses",
      chartId: "fetchOrganisationsWithWithoutCoursesData",
      options: dashboardGraphsOptions.TableChartOptions,
      otherActions: organisationsWithCoursesOtherActions("fetchOrganisationsWithWithoutCoursesData", otherActions, data),
    },
    {
      onScroll,
      onSortChange,
      boxWidth: "40%",
      chartType: TABLE,
      chartId: "fetchCourseCompletionData",
      options: dashboardGraphsOptions.TableChartOptions,
      //title: "Number of Completed / Incomplete Courses",
      title: "Course Completion",
      //otherActions: numberOfCompletedCoursesOtherActions(otherActions, data),
    },/*
    {
      onScroll,
      boxWidth: "85%",
      chartType: TABLE,
      title: 'Users by Course & Completion (%)',
      chartId: "fetchUsersByCourseCompletionData",
      isLoading: isLoadingMap?.fetchUsersByCourseCompletionData,
      data: data?.fetchUsersByCourseCompletionData?.data,
      options: dashboardGraphsOptions.TableChartOptions,
    },*/
    /*
    {
      onScroll,
      boxWidth: "20%",
      chartType: TABLE,
      title: "Number of Completed Courses",
      chartId: "fetchNumberOfCompletedCoursesData",
      options: dashboardGraphsOptions.TableChartOptions,
      data: data?.fetchNumberOfCompletedCoursesData?.data,
    },isLoading: isLoadingMap?.fetchUsersCompletedTrendsData,

    {
      onScroll,
      boxWidth: "20%",
      chartType: TABLE,
      title: 'Number of Incompleted Courses',
      chartId: "fetchNumberOfIncompleteCoursesData",
      options: dashboardGraphsOptions.TableChartOptions,
      data: data?.fetchNumberOfIncompleteCoursesData?.data,
    },isLoading: isLoadingMap?.fetchUsersCompletedTrendsData,
      */
  ];

  // Merge base configuration with API data and filter/sort
  const ChartsListData: ChartContainerProps[] = mergeChartConfigWithApiData(baseChartsConfig, graphs);

  return (
    <>
      <SummaryCardContainer summaryCardsData={data?.fetchSummaryCardsData?.data as any} />
      <div className="charts-container">
        {ChartsListData.map((props, idx) => {
          const chartId = props.chartId;
          if (!chartId) return null;
          return (
            <ChartContainer 
              {...props} 
              key={idx} 
              index={idx}
              queryParams={filters}
              exportActions={exportActions}
              data={data?.[chartId as keyof typeof data]?.data}
              total={data?.[chartId as keyof typeof data]?.total}
              endpoint={endpointsMap?.[chartId as keyof typeof endpointsMap]}
              isLoading={isLoadingMap?.[chartId as keyof typeof isLoadingMap]}
            />
          );
        })}
      </div>
      {hoveredRowStye !== null && (
        <div className='chart-hovered' style={hoveredRowStye}>
          <div className='chart-hovered-buttons'>
            <button
              className="close-button"
              about="tools"
              onClick={() => setHoveredRowStye(null)}
              style={{
                backgroundSize: '13px',
                backgroundImage: `url('${process.env.REACT_APP_PUBLIC_URL || process.env.PUBLIC_URL || ''}/close.png')`,
              }}
            />
          </div>
          <div style={{ width: "200px", height: "200px", color: "black" }}>
            <TableGraph data={selectedDataRowForTable} isFullHeight />
          </div>
        </div>
      )}
    </>
  );
};

export default Page3DashboardGraphs;
